import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class EmailIssue extends Model {
  campaign: EmailCampaign;
  countRecipients: number;
  name: string;
  subject: string;
  idCampaignIssue: number;
  mailingSize: number;
  messageHtml: string;
  messageText: string;
  numFinalRecipients: number;
  numRecipients: number;
  remainingRecipients: number;
  sentRecipients: number;
  isOldTemplate: boolean;
  sendStatus: string;
  uniqueOpens: number;
  opens: number;
  useSocial: boolean;
  webAnalytics: string;
  createDate: string;
  lastSaveTime: string;
  lastStopTime: string;
  sendDate: string;
}

export class EmailCampaign extends Model {
  title: string;
  description: string;
  idLanguage: string;
  emailSender: string;
  sender: string;
  replyTo: string;
  companyName: string;
  companyAddress: string;
  url: string;
  companyPhone: string;
  companyFax: string;
  status: string;
  createDate: string;
  idUser: number;
  optinSubject: string;
  sendToFriend: boolean;
  copyright: void;
}

export class EmailIssueArray extends Paginated {
  data: Array<EmailIssue>;
}

export class EmailPreview extends Model {
  htmlBody: string;
  textHtml: string;
}

export class DeletedEmailCampaignIssue extends Model {
  numDeleted: number;
}

export class EmailCampaignIssueStatistics extends Model {
  numContacts: number;
  numSent: number;
  numBounces: number;
  bouncesPercent: string;
  numTotalOpens: string;
  intNumTotalOpens: number;
  totalOpensPercent: string;
  numUniqueOpens: string;
  intNumUniqueOpens: number;
  uniqueOpensPercent: string;
  numForwards: string;
  intNumForwards: number;
  forwardsPercent: string;
  numUnsubscribe: string;
  intNumUnsubscribe: number;
  unsubscribePercent: string;
  numTotalWebVersion: string;
  intNumTotalWebVersion: number;
  numCliks: number;
  cliksPercent: string;
  status: string;
}

export class SizeAndTimeEmail extends Model {
  size: number;
  duration: number;
}

export class ExportEmailCsv extends Model {
  email: string;
}

export interface AddEmailIssueBody {
  name: string;
  subject: string;
  webAnalytics: string;
  useSocial: boolean;
}

export interface UpdateEmailIssue extends AddEmailIssueBody {
  idCampaign: number;
}

export interface SaveBodyHtmlBody {
  messageHtml?: string;
  messageText?: string;
  inlineHtml?: string;
}

export enum EmailHistoryStatus {
  DRAFT = 'DRAFT',
  RUNNING = 'RUNNING',
  SENT = 'SENT',
  SCHEDULED = 'SCHEDULED',
  ARCHIVED = 'ARCHIVED',
  ERROR = 'ERROR',
  DELETABLE = 'DELETABLE',
  PAUSED = 'PAUSED',
  ENQUEUED = 'ENQUEUED',
  TO_ENQUEUE_RECIPIENTS = 'TO_ENQUEUE_RECIPIENTS',
  BLOCKED = 'BLOCKED'
}

export enum EmailCampaignStatusHTMLSpanDraw {
  SENT = '<span class="badge badge-sent">',
  ERROR = '<span class="badge badge-error">',
  DRAFT = '<span class="badge badge-email-draft">',
  SCHEDULED = '<span class="badge badge-email-scheduled">'
}

export enum EmailStatsChartsLabels {
  DELIVERED = 'stats_mail_recipients_pie_sent',
  BOUNCES = 'stats_mail_recipients_pie_errors'
}
